import React, { useEffect, useState } from 'react';

import backgroundImage from './2FVISUAL_Background.jpg';
import logoImage from './2FVISUAL_logo.png';
import sloganImage from './2FVISUAL_Slogan.png';
import tourImage from './2FVISUAL_Tour.png';
import cgiImage from './2FVISUAL_cgi.png';

import './style.scss';

const IntroLoading = (props) => {
  const { onClosing, onClosed } = props;
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    // Close component after 10 seconds
    const animationDuration = 10000; // 10 seconds total

    setTimeout(() => {
      onClosing && onClosing();
      
      document.getElementById("intro-loading-container").classList.add('off');
      setTimeout(() => {
        setEnabled(false);
        onClosed && onClosed();
        window.logMessage('Intro loading closed');
      }, 1000);
      
    }, animationDuration);
  }, [onClosing, onClosed]);

  if (!enabled) return null;

  return (
    <div
      id="intro-loading-container"
      className="intro-loading-container"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="intro-loading-content">
        {/* Logo */}
        <img src={logoImage} alt="Logo" className="intro-image logo" />

        {/* Slogan */}
        <img
          src={sloganImage}
          alt="Slogan"
          className="intro-image slogan"
        />

        {/* Tour */}
        <img src={tourImage} alt="Tour" className="intro-image tour" />

        {/* CGI */}
        <img src={cgiImage} alt="CGI" className="intro-image cgi" />
      </div>
    </div>
  );
};

export default IntroLoading;
